export const enum ChangeVisibilityType {
  ShowLogin = 'showLogin',
  LoggedIn = 'loggedIn',
  BackToShop = 'backToShop'
}

export interface ProductBookingLoginGuardState {
  isLoginVisible: boolean;
  isDisabledProductBookingLogin: boolean;
  isProductSelectionVisible: boolean;
}
